import { __assign, __read, __rest } from "tslib";
import React, { useState } from "react";
import { Pagination, defaultPageSizeOptions, } from "../../pagination/Pagination";
export function pageable(options) {
    if (options === void 0) { options = {}; }
    return {
        getInfo: function () { return ({ name: "pageable" }); },
        onInjectTable: function (render) { return function (props) {
            var records = props.records;
            var _a = options.recordCount, recordCount = _a === void 0 ? records.length : _a, paginationProps = __rest(options, ["recordCount"]);
            return (React.createElement(TablePagination, __assign({ tableProps: props, tableRender: render }, paginationProps, { recordCount: recordCount })));
        }; },
    };
}
function TablePagination(_a) {
    var 
    // Table
    tableRender = _a.tableRender, tableProps = _a.tableProps, 
    // Pagination
    recordCount = _a.recordCount, pageSizeOptions = _a.pageSizeOptions, pageIndex = _a.pageIndex, pageSize = _a.pageSize, _b = _a.onPagingChange, onPagingChange = _b === void 0 ? function () { } : _b, props = __rest(_a, ["tableRender", "tableProps", "recordCount", "pageSizeOptions", "pageIndex", "pageSize", "onPagingChange"]);
    if (!Array.isArray(pageSizeOptions) || pageSizeOptions.length === 0) {
        pageSizeOptions = defaultPageSizeOptions; // eslint-disable-line no-param-reassign
    }
    // 为非受控组件提供状态管理
    var _c = __read(useState({
        pageIndex: 1,
        pageSize: pageSizeOptions[0],
    }), 2), internalPaging = _c[0], setInternalPaging = _c[1];
    // 非受控组件，使用内部状态
    if (typeof pageIndex === "undefined") {
        // eslint-disable-next-line prefer-destructuring,no-param-reassign
        pageIndex = internalPaging.pageIndex;
    }
    if (typeof pageSize === "undefined") {
        // eslint-disable-next-line prefer-destructuring,no-param-reassign
        pageSize = internalPaging.pageSize;
    }
    // 状态改变同时更新内部状态和通知外部
    // eslint-disable-next-line no-param-reassign
    onPagingChange = (function (onPagingChange) { return function (query) {
        setInternalPaging(query);
        onPagingChange(query);
    }; })(onPagingChange);
    var records = tableProps.records;
    return (React.createElement(React.Fragment, null,
        tableRender(__assign(__assign({}, tableProps), { records: records.length < recordCount
                ? records
                : records.slice((pageIndex - 1) * pageSize, pageIndex * pageSize) })),
        React.createElement(Pagination, __assign({}, props, { recordCount: recordCount, pageSizeOptions: pageSizeOptions, pageIndex: pageIndex, pageSize: pageSize, onPagingChange: onPagingChange }))));
}
//# sourceMappingURL=pageable.js.map